import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { getAllRegionSettings,getAlarmStatusColorList, addAlarmStatusColor } from '../action/alarmStatusColorAction';
import AlarmStatusColorComponent from '../components/alarmStatusColorComponent';

export class AlarmStatusColorContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getAllRegionSettings();
    }
       getUserList = (data) =>{
                            this.props.actions.getAlarmStatusColorList(data
                            )
                        }
                        getRegionData = () => {
                                                                         this.props.actions.getAllRegionSettings(this.props.dispatch);
                                                                      } 
    getSMTPdata = () =>{
        this.props.actions.getAlarmStatusColorList(
            this.props.dispatch
        )
    }
    
    updateAlarmStatusColor = (payload) =>{
        this.props.actions.addAlarmStatusColor(
            payload,
            this.props.dispatch
        )
    }
    render(){
        return(
            <AlarmStatusColorComponent
            updateStatusColor = {this.updateAlarmStatusColor}
            getAllAlarmStatusData = {this.props.alarmStatusData}
            getRegionList={this.getRegionData}
                    getUserList ={this.getUserList}
            // getSMTPdata = {this.getSMTPdata}
            >
            </AlarmStatusColorComponent>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAlarmStatusColorList,
            addAlarmStatusColor,
            getAllRegionSettings
        },
            dispatch)
    };
}
function mapStateToProps({ AlarmStatusColorReducer }) {
    console.log(AlarmStatusColorReducer);
    return {
        alarmStatusData : {
            errorCode : AlarmStatusColorReducer.errorCode,
            statusCode : AlarmStatusColorReducer.statusCode,
            alarmStatusColorList : AlarmStatusColorReducer.alarmStatusColorList,
            message : AlarmStatusColorReducer.message,
            isLoading : AlarmStatusColorReducer.isLoading,
            regionList : AlarmStatusColorReducer.regionList,
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AlarmStatusColorContainer));
